import * as Yup from "yup";
import "yup-phone";
import { t } from "i18next";

export const FirmSchema = Yup.object({
  // `${t("hospital.validation.name")}`
  name: Yup.string().min(0).max(100,`${t("hospital.validation.max-name")}`).matches(/^[0-9a-zA-Z&._ -]+$/, '').required("Name is required"),
  address: Yup.string().min(0).max(255,`${t("hospital.validation.max-address")}`).matches(/^[0-9a-zA-Z\s&#.\/, -]+$/, '').required("Address is required"), 
  country: Yup.string().min(1).required("Country is required"), 
  state: Yup.string().min(1).required("State is required"), 
  city: Yup.string().min(1).required("City is required"), 
  // priorityStudies: Yup.string().min(1).required("Study count is required"), 
  // contact1: Yup.object({}).shape({
  //   name: Yup.string().min(0).max(40).required(`${t("hospital.validation.contact.name")}`),
    // email: Yup.string().required(`${t("hospital.validation.contact.mail")}`).matches("^((([!#$%&'*+\\-/=?^_`{|}~\\w])|([!#$%&'*+\\-/=?^_`{|}~\\w][!#$%&'*+\\-/=?^_`{|}~\\.\\w]{0,}[!#$%&'*+\\-/=?^_`{|}~\\w]))[@]\\w+([-.]\\w+)*\\.\\w+([-.]\\w+)*)$",`${t("hospital.validation.contact.mail")}`),
    // type: Yup.string().min(0).max(40).required(`${t("hospital.validation.contact.type")}`),
    // mobile: Yup.number().min(0).max(12).required(`${t("hospital.validation.contact.mobile")}`),
    // landline: Yup.number().min(0).max(12).required(`${t("hospital.validation.contact.landline")}`)
  // })
  // contact1: Yup.object()
  // .shape({
  //   name: Yup.string().ensure().required(),
  //   email: Yup.string().ensure().required(),
  // })
  // .required("Country cannot be empty")
  // .nullable()
  // contact1 : Yup.object().shape({
  //   optionalObject: Yup.object().shape({
  //     name: Yup.string().required("gfdxfgx"),
  //   }),
  // })
});
